import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISlotList } from "../../../Pages/Slot/ISlot";

export const SlotSlicer = createSlice({
  name: "Slot",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISlotList[]>,
  reducers: {
    getSlot: (state) => {
      state.isLoading = true;
    },
    successGetSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getSlot, failureGetSlot, successGetSlot } =
  SlotSlicer.actions;

export default SlotSlicer.reducer;
